<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="settings.normal_work_price"
          field-name="normal_work_price"
          rules="required|numeric"
          type="numeric"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="settings.professional_work_price"
          field-name="professional_work_price"
          rules="required|numeric"
          type="numeric"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="settings.social_work_price"
          field-name="social_work_price"
          rules="required|numeric"
          type="numeric"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.training_student_edit_on"
          :label="$t('fields.training_student_edit_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.plane_document_expiration_notification_on"
          :label="$t('fields.plane_document_expiration_notification_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.user_document_expiration_notification_on"
          :label="$t('fields.user_document_expiration_notification_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.operating_day_notification_on"
          :label="$t('fields.operating_day_notification_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.balance_summary_notification_on"
          :label="$t('fields.balance_summary_notification_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.balance_notification_on"
          :label="$t('fields.balance_notification_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.automatic_membership_fee_deduction_on"
          :label="$t('fields.automatic_membership_fee_deduction_on')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="settings.night_reservation_on"
          :label="$t('fields.night_reservation_on')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditOrganizationSettings',
    props: {
      settings: Object,
    },
  }
</script>
